import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { KompisPillGroupCarousel } from '@inter-ikea-kompis/react-components';
import { PillSizeOptionsEnum } from '@inter-ikea-kompis/component-pill';
import PillAlignEnum from '@inter-ikea-kompis/component-pill/lib/enums/PillAlignEnum';
import Box from 'ui/Box';
import { SpaceProps } from 'styled-system';
import styled from 'styled-components';
import { e2e } from 'utils/queryUtils';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { getSelectedRange } from 'ducks/range';

const Wrapper = styled(Box)`
  width: 100%;
`;

type PillItem = {
  id: string;
  name: string;
  icon?: string;
};

type Props = SpaceProps & {
  items: PillItem[];
  onSelect: (id: string) => void;
  hideIcons?: boolean;
};

type ChangeEvent = {
  detail: {
    selectedIndex: number;
  };
};

type ItemIndexMap = {
  [index: number]: PillItem;
};

const PillGroupCarousel = ({ items, onSelect, ...props }: Props) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  const itemsWithIndex: ItemIndexMap = items.reduce((acc, curr, i) => ({ ...acc, [i]: curr }), {});
  const selectedRange = useSelector(getSelectedRange);

  useEffect(() => {
    // Scroll pills to start when selected range changes.
    setSelectedIndex(0);
  }, [selectedRange]);

  const onPillSelected = (event: ChangeEvent) => {
    const index = event?.detail?.selectedIndex;
    const selected = itemsWithIndex[index];

    if (selected) {
      onSelect(selected.id);
    }
  };

  const onChange = (event: ChangeEvent) => {
    setSelectedIndex(event.detail.selectedIndex);
  };

  return (
    <Wrapper {...props}>
      <KompisPillGroupCarousel
        theme={SkapaTheme}
        onChange={onChange}
        onSelect={onPillSelected}
        selectedIndex={selectedIndex}
        showArrows={!e2e()}
        pillItems={items.map(item => ({
          name: item.name,
          icon: props.hideIcons ? undefined : item.icon
        }))}
        pillSize={PillSizeOptionsEnum.medium}
        alignIcon={PillAlignEnum.left}
      />
    </Wrapper>
  );
};

export default PillGroupCarousel;
